// Mock data for Drakify Express website

export const brands = [
  { id: 1, name: 'Kodak' },
  { id: 2, name: 'DJI' },
  { id: 3, name: 'Casio' },
  { id: 4, name: 'Nintendo' },
  { id: 5, name: 'Insta360' },
  { id: 6, name: 'Samsung' },
  { id: 7, name: 'Sony' },
  { id: 8, name: 'GoPro' },
  { id: 9, name: 'Canon' },
  { id: 10, name: 'Nikon' },
  { id: 11, name: 'Panasonic' },
  { id: 12, name: 'Fujifilm' }
];

export const companyInfo = {
  name: 'Drakify Express',
  founded: 2022,
  email: 'info@drakifyexpress.com',
  address: 'Dubai Silicon Oasis, DDP Building A2, Dubai, United Arab Emirates',
  whatsapp: '+971581586814'
};

export const visionMission = {
  vision: 'To be the leading wholesale supplier of premium electronics and technology products across the Middle East, delivering exceptional value and service to our business partners.',
  mission: 'We are committed to providing businesses with authentic, high-quality electronics at competitive wholesale prices, backed by reliable express delivery and outstanding customer support. Our goal is to empower retailers and businesses to succeed through seamless procurement solutions.'
};

export const wholesaleInfo = {
  title: 'Why Choose Us as Your Wholesale Supplier?',
  description: 'Drakify Express is your trusted wholesale partner for premium electronics. We specialize in bulk orders and B2B supply chains, offering competitive pricing and reliable service.',
  benefits: [
    {
      title: 'Bulk Order Discounts',
      description: 'Enjoy significant savings with our tiered pricing structure. The more you order, the more you save. Special rates for recurring wholesale orders.'
    },
    {
      title: 'B2B Payment Terms',
      description: 'Flexible payment options including net 30/60 terms for established business partners. Trade credit available for qualified retailers.'
    },
    {
      title: 'Dedicated Account Manager',
      description: 'Each wholesale client gets a dedicated account manager to handle your orders, inquiries, and ensure smooth business operations.'
    },
    {
      title: 'Express Shipping & Logistics',
      description: 'Fast delivery across UAE and Middle East. Track your wholesale shipments in real-time with our advanced logistics system.'
    },
    {
      title: 'Authorized Distributor',
      description: 'We are authorized distributors for all major brands. Every product comes with manufacturer warranty and authenticity guarantee.'
    },
    {
      title: 'Inventory Management Support',
      description: 'Real-time stock updates, low inventory alerts, and automatic reordering options to keep your shelves stocked.'
    }
  ]
};

export const supplierStats = [
  { label: 'Active Retail Partners', value: '500+' },
  { label: 'Products in Catalog', value: '10,000+' },
  { label: 'Countries Served', value: '15+' },
  { label: 'Years in Business', value: '3+' }
];

export const reviews = [
  {
    id: 1,
    name: 'Ahmed Hassan',
    company: 'Tech Retailers LLC',
    rating: 5,
    comment: 'Excellent wholesale partner! Fast delivery and authentic products.',
    date: '2024-01-15'
  },
  {
    id: 2,
    name: 'Sarah Al Mansouri',
    company: 'Dubai Electronics Hub',
    rating: 5,
    comment: 'Best prices in the market. Their customer service is outstanding.',
    date: '2024-01-10'
  },
  {
    id: 3,
    name: 'Mohammed Ali',
    company: 'Gulf Tech Distributors',
    rating: 4,
    comment: 'Great selection of brands. Reliable and professional service.',
    date: '2024-01-05'
  }
];
